import { render, staticRenderFns } from "./premiumModel.vue?vue&type=template&id=2105d2de&scoped=true"
import script from "./premiumModel.vue?vue&type=script&lang=js"
export * from "./premiumModel.vue?vue&type=script&lang=js"
import style0 from "./premiumModel.vue?vue&type=style&index=0&id=2105d2de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2105d2de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2105d2de')) {
      api.createRecord('2105d2de', component.options)
    } else {
      api.reload('2105d2de', component.options)
    }
    module.hot.accept("./premiumModel.vue?vue&type=template&id=2105d2de&scoped=true", function () {
      api.rerender('2105d2de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/mobilePreview/components/premiumModel.vue"
export default component.exports